import BaseAccountController from '../../lib/controllers/BaseAccountController';

export default class EmergencyContactsController extends BaseAccountController {
	public static $inject: string[] = ['$scope', 'EmergencyContactsResource'];

	public emergencyContacts: MyAccountApi.IEmergencyContacts;
	public generalError: string;
	public generalMessage: string;
	public phoneInputs: {
		[key: string]: string | null
	};
	public deleteDialogLoading: boolean;
	public secondaryTitle: string;
	public secondaryActionText: string;
	public isAddMode: boolean;

	private readonly EmergencyContacts: MyAccountApi.IEmergencyContactsResource;
	private readonly viewModeSecondaryTitle: string = 'Secondary Emergency Contact';
	private readonly viewModeSecondaryActionTextWhenSingleContact: string = 'Add New Emergency Contact';
	private readonly viewModeSecondaryActionTextWhenTwoContacts: string = 'Remove Secondary Contact';
	private readonly editModeSecondaryTitle: string = 'Add New Emergency Contact';
	private readonly editModeSecondaryActionText: string = 'Cancel';

	constructor($scope: ng.IScope, EmergencyContacts: MyAccountApi.IEmergencyContactsResource) {
		super($scope);

		this.EmergencyContacts = EmergencyContacts;
		this.phoneInputs = {};
	}

	public setSecondaryText(): void {
		this.secondaryTitle = this.isAddMode ? this.editModeSecondaryTitle : this.viewModeSecondaryTitle;

		if (this.emergencyContacts.backupContact == null) {
			this.secondaryActionText = this.viewModeSecondaryActionTextWhenSingleContact;
		} else {
			this.secondaryActionText = this.isAddMode ? this.editModeSecondaryActionText : this.viewModeSecondaryActionTextWhenTwoContacts;
		}
	}

	public canEdit(): boolean {
		return this.emergencyContacts && !this.emergencyContacts.viewOnly;
	}

	public translatePhoneInput(form: ng.IFormController, label: string): void {
		const ctrl = form[`${label}PhoneNumber`];

		if (ctrl.$valid) {
			const input = this.phoneInputs[label]!;
			let contact: MyAccountApi.IEmergencyContact;

			if (label === 'primary') {
				contact = this.emergencyContacts.primaryContact as MyAccountApi.IEmergencyContact;
			} else {
				contact = this.emergencyContacts.backupContact as MyAccountApi.IEmergencyContact;
			}

			contact.contactPhone.areaCode = input.substring(0, 3);
			contact.contactPhone.prefix = input.substring(3, 6);
			contact.contactPhone.suffix = input.substring(6);
		}
	}

	public canUpdate(form: ng.IFormController): string | undefined {
		let canUpdateError: string | undefined;

		if (!form.$valid) {
			canUpdateError = 'There are errors with the emergency contacts information, please check your input and' +
				' try again';
		}

		return canUpdateError;
	}

	public addBackup(): void {
		this.emergencyContacts.backupContact = {
			membershipId: this.emergencyContacts.primaryContact.membershipId,
			contactName: {
				first: '',
				middle: '',
				last: '',
				prefix: '',
				suffix: ''
			},
			contactPhone: {
				areaCode: '',
				prefix: '',
				suffix: '',
				valid: true,
				type: 'PHONE_CONTACT'
			}
		};

		this.generalMessage = '';
		this.generalError = '';

		this.isAddMode = true;
		this.setSecondaryText();
	}

	public secondaryAction(): void {
		if (this.isAddMode) {
			this.cancelAdd();
		} else {
			this.removeBackup();
		}
	}

	public cancelAdd(): void {
		this.isAddMode = false;
		this.emergencyContacts.backupContact = null;
		this.phoneInputs.backup = null;
		this.setSecondaryText();
	}

	public removeBackup(): void {
		this.deleteDialogLoading = false;

		$('#deleteModal').modal();
	}

	public removeBackupConfirmed(): void {
		this.deleteDialogLoading = true;

		this.emergencyContacts.backupContact = null;
		this.phoneInputs.backup = null;
		this.setSecondaryText();
		this.isAddMode = false;

		this.saveEmergencyContacts().then(() => {
			this.generalMessage = 'You’ve successfully deleted your emergency contact information.';
		}).finally(() => {
			$('#deleteModal').modal('hide');
		});
	}

	public update(form: ng.IFormController): string | undefined {
		const canUpdateError = this.canUpdate(form);
		this.generalMessage = '';

		if (!canUpdateError) {
			this.saveEmergencyContacts();
		} else {
			this.generalMessage = '';
			this.generalError = canUpdateError;
		}

		return canUpdateError;
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		this.emergencyContacts = this.EmergencyContacts.get((emergencyContacts: MyAccountApi.IEmergencyContacts) => {
			this.setSecondaryText();

			this.phoneInputs.primary = this.friendlyPhone(emergencyContacts.primaryContact.contactPhone);
			if (emergencyContacts.backupContact != null) {
				this.phoneInputs.backup = this.friendlyPhone(emergencyContacts.backupContact.contactPhone);
			}
		});
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}

	private saveEmergencyContacts(): ng.IPromise<MyAccountApi.IEmergencyContacts> {
		this.generalMessage = '';
		this.generalError = '';

		return this.emergencyContacts.$save(() => {
			this.isAddMode = false;
			this.setSecondaryText();
			if (this.secondaryActionText === this.viewModeSecondaryActionTextWhenSingleContact) {
				this.generalMessage = 'You’ve successfully updated your emergency contact information.';
			} else {
				this.generalMessage = 'You’ve successfully added your emergency contact information.';
			}
		}, (err: string) => {
			this.generalError = err;
		});
	}

	private friendlyPhone(phone: MyAccountApi.IPhoneNumber): string {
		return `${phone.areaCode}${phone.prefix}${phone.suffix}`;
	}
}
